export default __webpack_public_path__ + "static/media/Scholar's Doublet of Awakening.876b0e7b.jpg";